import { FC } from 'react';

import successImage from '@/assets/form-images/form-success.svg';
import Image from '@/components/image';
import ModalContent from '@/components/lottery-form/modals/content';
import getVariablePlainText from '@/lib/get-variable-plain-text';
import useVariables from '@/lib/hooks/use-variables';

const SuccessModalContent: FC = () => {
  const variables = useVariables();
  const title = getVariablePlainText(variables['form-success-title']);
  const text = variables['form-success-text'];

  return (
    <ModalContent
      image={
        <Image
          src={successImage.src}
          alt="Participation successful"
          className="aspect aspect-2-1"
        />
      }
      title={title}
      text={text}
    />
  );
};

export default SuccessModalContent;
